<template lang="pug">
  v-card.sdo-card
    v-card-text
      .title {{ user.full_name }}
      v-list
        v-list-item(v-if="user.name")
          v-list-item-content
            v-list-item-subtitle Логин
            v-list-item-title {{ user.name }}
        v-list-item(v-if="user.email")
          v-list-item-content
            v-list-item-title Почта
            v-list-item-subtitle {{ user.email }}
      template(v-if="user.attributes.length > 0")
        p Заполните дополнительные поля
        attributes-form(
          :method="saveAttrs"
          :attributes="noRequiredAttrs"
          no-disable-attrs
        )
</template>

<script>
import AttributesForm from '@/components/Forms/AttributesForm.vue';

export default {
  components: {
    AttributesForm,
  },
  props: {
    user: { type: Object, required: true },
    recordId: { type: Number, required: true },
  },
  data() {
    return {
      value: {},
      initial: {},
    };
  },
  computed: {
    noRequiredAttrs() {
      return this.user.attributes.map((item) => ({
        ...item,
        is_required: false,
      }));
    },
  },
  // watch: {
  //   user() {
  //     this.parseUserAttrs();
  //   },
  // },
  // created() {
  //   this.parseUserAttrs();
  // },
  methods: {
    // parseUserAttrs() {
    //   this.user.attributes.forEach((attr) => {
    //     this.value[attr.id] = attr.value;
    //   });
    //   this.initial = { ...this.value };
    // },
    saveAttrs({ attributes, obs }) {
      const payloads = [{
        user_id: this.user.id,
        attributes,
      }];
      return this.$rHandler(
        this.$api.courses.staffRecordsSaveAttributes(this.recordId, payloads),
        () => {
          this.$emit('saved', this.user.id);
        },
        (resp) => new Error(resp),
        obs,
      );
    },
  },
};
</script>
